<template>
    <div>
      <h1 class="page-heading">Mon profil</h1>
    </div>
  </template>
  
  <script>
  import { defineComponent } from 'vue'
  
  export default defineComponent({
    name: 'ProfileView'
  })
  </script>